// HashtagIndex.jsx
'use strict';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import HashtagCategoryGrid from '../container/HashtagCategoryGrid.js';

import { color } from '../style/variables.js';
import media from '../style/media.js';

export const HashtagIndex = ({
  meId,
  hashtagCategories,
  fetchTranslationByKey,
}) => {
  useEffect(() => {
    if (hashtagCategories.length > 0) {
      fetchTranslationByKey({
        groups: hashtagCategories,
      });
    }
  }, [meId, hashtagCategories, fetchTranslationByKey]);
  return (
    <StyledHashtagIndex>
      <Body>
        {hashtagCategories.map(category => (
          <CategoryWrapper key={category}>
            <HashtagCategoryGrid category={category} />
          </CategoryWrapper>
        ))}
      </Body>
    </StyledHashtagIndex>
  );
};

HashtagIndex.propTypes = {
  meId: PropTypes.string,
  hashtagCategories: PropTypes.array,
  fetchTranslationByKey: PropTypes.func,
};

HashtagIndex.defaultProps = {
  meId: null,
  hashtagCategories: [],
  fetchTranslationByKey: () => null,
};

const StyledHashtagIndex = styled.div`
  min-height: 100vh;
  background-color: ${color.black};
`;

const Body = styled.div`
  padding: 32px 60px 60px;
  ${media.mobile`
    padding: 16px;
  `};
`;

const CategoryWrapper = styled.div`
  margin-bottom: 32px;
  ${media.mobile`
    margin-bottom: 24px;
  `};
`;

export default HashtagIndex;
